import React, { useEffect, useState } from "react";

interface TechCardProps {
  title: string;
  notes: string;
  stage: string;
  misc: string;
  index: number;
}

const TechCard: React.FC<TechCardProps> = ({
  title,
  notes,
  stage,
  misc,
  index,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, index * 200);

    return () => clearTimeout(timeout);
  }, [index]);

  return (
    <div className={`tech-card ${isVisible ? "visible" : ""}`}>
      <div className="tech-card-title">
        {title}
        <span className="tech-card-section-title">Title</span>
      </div>

      <div className="tech-card-section">
        <span className="tech-card-section-title">Notes</span>
        <p>{notes}</p>
      </div>

      <div className="tech-card-section">
        <span className="tech-card-section-title">Stage</span>
        <p>{stage}</p>
      </div>

      <div className="tech-card-section">
        <span className="tech-card-section-title">Misc</span>
        <p>{misc}</p>
      </div>
    </div>
  );
};

export default TechCard;
